var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "van-popup",
        {
          style: { padding: "0 15px 15px", width: "200px" },
          attrs: { round: "" },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c(
            "h2",
            { staticStyle: { "font-size": "20px", "line-height": "40px" } },
            [_vm._v("温馨提示")]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticStyle: {
                "font-size": "14px",
                "line-height": "28px",
                "text-indent": "2em"
              }
            },
            [_vm._v("您还未填写手机号，为了您更好的体验，请立即前往！")]
          ),
          _vm._v(" "),
          _c(
            "van-row",
            { attrs: { justify: "space-between" } },
            [
              _c(
                "van-col",
                {
                  staticStyle: { "text-align": "center", margin: "10px 0 0" },
                  attrs: { span: "8" }
                },
                [
                  _c(
                    "van-button",
                    {
                      staticStyle: { "font-size": "12px" },
                      attrs: { type: "default" },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v("以后再说")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("van-col", { attrs: { span: "8" } }, [
                _c("div", { staticStyle: { width: "100%", height: "1px" } })
              ]),
              _vm._v(" "),
              _c(
                "van-col",
                {
                  staticStyle: { "text-align": "center", margin: "10px 0 0" },
                  attrs: { span: "8" }
                },
                [
                  _c(
                    "van-button",
                    {
                      staticStyle: { "font-size": "12px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.ok }
                    },
                    [_vm._v("立即填写")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f2df61a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f2df61a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Wxauth/Auth.vue
// module id = null
// module chunks = 